function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

class DiscoverySet {
    constructor() {
      this.selectors = {
        addButton: '.sample-block__add, .samples-block',
        removeButton: '.sample-block__remove',
        addToCart: '.product--custom-discovery-set button[data-product-add]',
        samplePlaceholder: '.sample-placeholder',
        predefinedSetButton: '.predefined-set'
      }
      this.items = [{}, {}, {}, {}, {},{}]
      this.addEventListeners()
      $(".product-form__error-message").text("Please select 6 samples.");
    }

    addEventListeners(){
      $(document).on('click', this.selectors.addButton, this.addSampleToSet.bind(this))
      $(document).on('click', this.selectors.removeButton, this.removeFromSampleSet.bind(this))
      // $(document).on('click', this.selectors.addToCart, this.addToCart.bind(this))
      // $(document).on('click', this.selectors.addToCart, this.addToCart.bind(this))
      $(document).on('click', this.selectors.samplePlaceholder, this.scrollToList.bind(this))
      $(document).on('click', this.selectors.predefinedSetButton, this.addInBulk.bind(this))

     // $(".sample-placeholder").on('click', this.scrollToList.bind(this))
    }

    async addInBulk(event) {
      $(".product-form__error-message").addClass('hidden')
      $(".predefined-set").removeClass('selected')
      $(event.currentTarget).addClass('selected')
      let ids = $(event.currentTarget).attr('data-products').split(",")
      $('.sample-block__remove').each(function() {
        $(this).trigger("click");
      })
      for(let i = 0; i < ids.length; i++) {
        $(`.sample-block__add[data-id="${ids[i]}"]`).trigger('click')
        await new Promise(resolve => setTimeout(resolve, 0.1 * 1000));
      }
      $(".product-form__error-message").removeClass('hidden');
    }

    scrollToList(event) {
      if(!$(event.currentTarget).hasClass('filled') && window.screen.width < 750) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(".product__collection-samples").offset().top - 100
        }, 100);
      }
    }
    addSampleToSet(event) {
      const container = $(event.currentTarget).closest(".samples-block")
      if(container.hasClass("samples-block--added")) return
      const target = $(".sample-placeholder:not(.filled)").first()
      const id = $(event.currentTarget).attr("data-id")
      const color = $(event.currentTarget).attr("data-border-color")
      const currentTotal = $(".sample-placeholder.filled").length
      const title = container.find('.sample-block__title').text();
      if(target.length) {
        const index = parseInt(target.attr('data-placeholder-index'))
        this.setImage(container, target)
        this.setTitle(title, target)
        this.setColor(color, target)
        this.setId(id, target)
        setTimeout(function() {
          target.addClass('filled');
        }, 100)
        this.items[index] = {
          title: title,
          id: id
        }

        this.updateHiddenInputs();       
        const allSelected = this.items.findIndex(e => !e.id) === -1
        container.addClass("samples-block--added")
        const selectedCount = this.items.filter(i => i.id).length
        if(allSelected) {
          $("button[data-product-add]").attr("disabled", false);
          $(".product-form__error-message-wrapper").addClass("hidden")
          $(".product-form__error-message").text("")
          $(".product-form__error-message").text("");
          this.updateProperties();
        } else {
          $(".product-form__error-message").text(`Please select ${6 - selectedCount} sample${selectedCount == 4 ? '' : 's'}.`);
        }
      }
    }

    removeFromSampleSet(event) {
      event.stopPropagation()
      let container = $(event.currentTarget).closest(".sample-placeholder")
      const id = $(event.currentTarget).attr("data-id")
      if(!container.length) {
        container = $(`.sample-placeholder [data-id="${id}"]`).closest(".sample-placeholder")
      }
      $(`.samples-block--added [data-id="${id}"]`).closest(".samples-block--added").removeClass("samples-block--added")
      container.removeClass("filled")
      const imagesToRemove = container.find("img")
      container.find('.sample-placeholder__title').text('');
      setTimeout(function() {
        imagesToRemove.remove();
      }, 1000)
      const index = parseInt(container.attr('data-placeholder-index'))
      this.items[index] = {}
      this.updateHiddenInputs();
      const selectedCount = this.items.filter(i => i.id).length
      const filledSamples = $(".sample-placeholder.filled").length;
      if (filledSamples < 6) {
        $("button[data-product-add]").attr("disabled", true);
        $(".product-form__error-message-wrapper").removeClass("hidden");
        // $(".product-form__error-message").text("Please select 5 samples.");
        $(".product-form__error-message").text(`Please select ${6 - selectedCount} samples.`);
      }
    }
    
  
    updateHiddenInputs() {
        const container = $(".discovery-hidden-inputs");
        container.empty();

        var timestamp = makeid(10);
      
        this.items.forEach((item, index) => {
          if (item.id) {
            container.append(`
              <input type="hidden" name="items[${index}][id]" data-index="${index}" value="${item.id}">
              <input type="hidden" name="items[${index}][quantity]" data-index="${index}" value="1">
              <input type="hidden" name="items[${index}][properties][_sample]" data-index="${index}" value="${timestamp}">
              <input type="hidden" name="items[${index}][properties][_index]" data-index="${index}" value="${index}">
            `);
          }
        });
        return timestamp;
      }

    updateProperties(event, timestamp){
      const proContainer = $(".dicovery-hidden-properties");
      proContainer.empty();
      var timestamp = this.updateHiddenInputs();
      
      proContainer.append(`
      <input type="hidden" name="properties[_discovery_set]" value="${timestamp}">
      <input type="hidden" name="properties[Sample 1]" value="${this.items[0].title}">
      <input type="hidden" name="properties[Sample 2]" value="${this.items[1].title}">
      <input type="hidden" name="properties[Sample 3]" value="${this.items[2].title}">
      <input type="hidden" name="properties[Sample 4]" value="${this.items[3].title}">
      <input type="hidden" name="properties[Sample 5]" value="${this.items[4].title}">
      <input type="hidden" name="properties[Sample 6]" value="${this.items[5].title}">
      `);  
    }

    setImage(container, target) {
      const img = container.find('img').clone()
      target.find('.sample-media').append(img)
    }

    setTitle(title, target) {
      target.find('.sample-placeholder__title').text(title)
    }

    setColor(color, target) {
      target.find('.sample-block__remove').css("border-color", color)
    }

    setId(id, target) {
      target.find('.sample-block__remove').attr("data-id", id)
      target.attr('data-variant',id)     
    }
  }
  document.addEventListener("DOMContentLoaded", function() {
    new DiscoverySet()
    $("button[data-product-add]").attr("disabled", "disabled");
  })


// bundle product remove

function bundleRemove(This) {
  var updates = {};
  var sampleId = $(This).closest('.parent_product').data('pro');
  var mainKey = $(This).closest('.parent_product').data('key');
  
  var childKeys = $('.child_product')
    .filter(function() {
      return $(this).data('pro') === sampleId;
    })
    .map(function() {
      return $(this).data('key');
    })
    .get().concat(mainKey);
  
  childKeys.forEach(function(key) {
    updates[key] = 0;
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: updates
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Failed to update cart');
    }
    return response.json();
  })
  .then(data => {
    if(window.location.path == '/'){
      location.reload();
    }else{
       window.RightDrawerInstance._updateCartDrawer(data);
    var itemCount = data.item_count > 0 ? data.item_count : '';
    $('[data-header-cart-count]').text(itemCount);
   }
  })
  .catch(error => {
    console.error('Error:', error);
  });
}


$(document).on('click','.parent_product .cart-item-remove , .parent_product #cart-item-remove-button',function(e){
  e.preventDefault();
  bundleRemove(this);
});
